import React from 'react'
import RoomContainer from './RoomContainer'

const Room = (props) => (
  <RoomContainer {...props} />
)

export default Room



// WEBPACK FOOTER //
// src/routes/Room/index.js